import { useSelector } from "react-redux";
import { RootState } from "../common/commonTypes";

export const useOrganizationMembers = (orgId: number) => 
  useSelector((state: RootState) => {
    return orgId ?  state.usersByOrgId[orgId] : [];
});